export default {
      id: "euestudante-white-usage",
      viewBox: "0 0 239.333 53",
      url: "/assets/svg/" + "sprite.svg#euestudante-white-usage",
      toString: function () {
        return this.url;
      }
    }